import { Heading } from 'almanac-ui/Heading/Heading'
import Styles from './Plan.module.scss'
import { Text } from 'almanac-ui/Text/Text'
import { Brainstorm, BrandVoice, Campaign, CaseStudies, Testimonial } from 'almanac-ui/icons/blaze/32'
import cx from 'classnames'
import { Button } from 'components/Button'
import { ArrowRight } from 'almanac-ui/icons/16'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { GhostButton } from 'components/Buttons/GhostButton'
import { ReactComponent as LeftArrowIcon } from 'assets/icons/arrowLeft24.svg'
import ProgressBar from 'screens/LoginOrSignup/components/ProgressBar/ProgressBar'
import Shared from 'screens/LoginOrSignup/Shared.module.scss'
import { usePaymentPlans } from 'hooks/usePaymentPlans'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { Integrations } from 'almanac-ui/icons/32'
import { kFormatter } from 'utils'
import { currencyFormatter } from 'components/Paywall/UpgradePlanModal/components/SelectPlan/components/PlanDetail/components/Features/Features'
import { Explanation } from '../Explanation/Explanation'
import { Spinner } from 'common/Spinner/Spinner'

interface Props {
  totalSteps?: number
  transitionPage: (page: string) => void
}

export const Plan = ({ totalSteps, transitionPage }: Props) => {
  const { isTabletPortrait } = useResponsiveDesign()
  const { paymentPlans } = usePaymentPlans()
  const creatorPlan = paymentPlans.find((plan) => plan.key === PaymentPlanKey.BlazeCreator)
  const aiWords = creatorPlan?.additionals?.ai_words
  const plagiarismChecks = creatorPlan?.additionals?.plagiarism_checks

  return (
    <div data-testid="plan" className={Styles.wrapper}>
      <div className={Styles.container}>
        <div className={cx(Styles.header, Shared.header)}>
          <GhostButton
            className={cx(Shared.backButton, Styles.backButton)}
            aria-label="Back"
            onClick={() => transitionPage('GO_BACK')}
          >
            <LeftArrowIcon />
          </GhostButton>
          {!isTabletPortrait && <p className={cx(Shared.title, Shared.isBlaze, Styles.title)}>Creator Plan</p>}
          {totalSteps && isTabletPortrait && <ProgressBar totalSteps={totalSteps} currentStep={5} />}
        </div>
        {isTabletPortrait && <p className={cx(Shared.title, Shared.isBlaze, Styles.title)}>Creator Plan</p>}
        <p className={Styles.subtitle}>
          Unlock the fastest way to create and ship with Blaze. Try it free for 7 days and get:
        </p>
        <div className={Styles.content}>
          {!aiWords || !plagiarismChecks ? (
            <Spinner className={Styles.loadingSpinner} />
          ) : (
            <div className={Styles.items}>
              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <Brainstorm />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>{kFormatter(aiWords?.plan_limit)} AI Generated Words,</Heading>
                  <Text variant="p2">
                    then {currencyFormatter(aiWords?.monthly_price)} per {kFormatter(aiWords?.amount_per_unit)} words
                  </Text>
                </div>
              </div>

              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <BrandVoice />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>3 Brand Voices</Heading>
                </div>
              </div>

              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <Campaign />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>Unlimited Multi Channel Campaigns</Heading>
                </div>
              </div>

              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <CaseStudies />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>{kFormatter(plagiarismChecks?.plan_limit)} Plagiarism Checks,</Heading>
                  <Text variant="p2">then {currencyFormatter(plagiarismChecks?.monthly_price)} per check</Text>
                </div>
              </div>

              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <Testimonial />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>Unlimited guest access to docs & projects</Heading>
                </div>
              </div>

              <div className={Styles.item}>
                <div className={Styles.icon}>
                  <Integrations />
                </div>
                <div className={Styles.text}>
                  <Heading level={4}>Powerful Integrations</Heading>
                </div>
              </div>
            </div>
          )}

          <div className={Styles.bottomContent}>
            <Button
              variant="blazePrimary"
              className={Styles.submitButton}
              type="submit"
              size="xl"
              endIcon={ArrowRight}
              onPress={() => transitionPage(isTabletPortrait ? 'NEXT_EXPLANATION' : 'NEXT_TRIAL')}
            >
              Try it free for 7 days
            </Button>
            <span className={Styles.smallPrint}>Cancel anytime, we’ll remind you before trial ends.</span>
          </div>
        </div>
      </div>
      {!isTabletPortrait && <Explanation transitionPage={transitionPage} />}
    </div>
  )
}
